<template>
  <div class="expired">
    <span class="load" v-if="loading" style="line-height: 88px;color: #666;font-size: 20px;width: 100%;text-align: center;margin-left:40%;">加载中...</span>
    <div v-else>
      <div class="e-box1">
        <i class="iconfont icon-warning1"></i>
        <div>账号到期提醒</div>
      </div>
      <div class="e-box2">
        {{ info }}
      </div>
      <div class="e-box3">
        <span >系统通知</span>
        <span class="time">{{ createTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { expirationUser } from '@/api/abnormal'

export default {
  name: 'expired' ,
  data() {
    return {
      openid: '',
      createTime: '',
      info: '',
      loading: true
    }
  },
  mounted() {
    let query = this.$route.query;
    this.$store.state.userInfo.openid = query.openId
    this.openid = query.openId
    this.createTime = query.createTime
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      const res = await expirationUser(
        {
          openId: this.openid,
          createTime: this.createTime
        }
      )
      if(res.status == 200){
        this.info = res.data.content 
        this.createTime = res.data.createTime
        this.loading = false
      }
    }
  },

}
</script>

<style scoped>
	@import './expired.css';
</style>